import {ReportFilterBase} from './reportFilterBase';

export class ReportFilterByTerminalID extends ReportFilterBase{

    terminalID = 0;

}
